import { render, staticRenderFns } from "./ComparisonTableGroupFixedColumn.vue?vue&type=template&id=53d79596&scoped=true&"
import script from "./ComparisonTableGroupFixedColumn.vue?vue&type=script&lang=js&"
export * from "./ComparisonTableGroupFixedColumn.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonTableGroupFixedColumn.vue?vue&type=style&index=0&id=53d79596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d79596",
  null
  
)

export default component.exports